<div class="modal-header">
    <h5 class="modal-title">
        {{ DESIGNER_TITLE | translateTokenisedString }} | {{ config.name }}
    </h5>
    <button wdxIconButton (click)="activeModal.dismiss()">
        <wdx-icon icon="xmark"></wdx-icon>
    </button>
</div>

<div class="modal-body overflow-hidden d-flex flex-column">
    <div class="px-4 py-2 active-component d-flex align-items-center">
        <button wdxButton class="ms-auto" (click)="saveWorkflow()">
            {{ 'WORKFLOW_SAVE' | translateTokenisedString }}
        </button>
    </div>
    <div class="d-flex flex-grow-1 overflow-hidden">
        <div #leftPanel class="w-25 bg-body me-3 p-3 overflow-auto">
            @if (workflowContext$ | ngrxPush; as ctx) {
                @if (ctx.node) {
                    <clmi-workflow-designer-parameters
                        [context]="ctx"
                        [componentProvider]="componentProvider"
                        (paramsChanged)="onParamsChanged($event)"
                    ></clmi-workflow-designer-parameters>
                } @else if (showingStepSelection$ | ngrxPush) {
                    <clmi-workflow-designer-steps
                        [steps]="groupedSteps$ | ngrxPush"
                        (stepClicked)="onStepClicked($event)"
                    ></clmi-workflow-designer-steps>
                } @else {
                    <p>Please select an existing node or add a new one</p>
                }
            }
        </div>
        <div class="w-75 bg-body p-3 overflow-auto">
            <clmi-workflow-designer-visual
                [workflowNodes]="workflowNodes$ | ngrxPush"
                [activeNodeId]="activeNodeId"
                (selectNode)="onNodeSelected($event)"
                (addNode)="onNodeAdd($event)"
                (removeNode)="onNodeRemove($event)"
            ></clmi-workflow-designer-visual>
        </div>
    </div>
</div>
